import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';

import { MobileSearchBlock } from 'shared/components/MobileSearchBlock';
import { SearchBlockModalContainer } from '../SearchBlockModalContainer';
import { DesktopSearchBlockLayout } from 'shared/components/DesktopSearchBlockLayout/DesktopSearchBlock';
import { DesktopSearchInputContainer } from '../DesktopSearchInputContainer';
import { SearchTipsContainer } from '../SearchTipsContainer/SearchTipsContainer';

import { Responsive } from '@cian/ui-kit';
import { useApplicationContext } from '../ApplicationContext';
import { EPageType } from 'shared/types/pageType';

export const SearchBlockContainer: React.FC = () => {
  const { custom } = useApplicationContext();

  const { state: isModalOpen, setTrue: setModalOpen, setFalse: setModalClose } = useBooleanState(false);

  const isMainpage = custom.pageType === EPageType.MAIN;

  const handleSearchButtonClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      setModalOpen();
    },
    [setModalOpen],
  );

  return (
    <>
      <Responsive desktop>
        <DesktopSearchBlockLayout>
          <DesktopSearchInputContainer />
          <SearchTipsContainer isMainPageTips={true} desktopStyle={true} onClick={() => {}} />
        </DesktopSearchBlockLayout>
      </Responsive>
      <Responsive phone tablet>
        <MobileSearchBlock onSearchClick={handleSearchButtonClick} isMainpage={isMainpage} />
        <SearchBlockModalContainer open={isModalOpen} onClose={setModalClose} />
      </Responsive>
    </>
  );
};

SearchBlockContainer.displayName = 'SearchBlockContainer';
